export const BRAND_PRIMARY = "var(--color-primary)";
export const BRAND_SECONDARY = "var(--color-secondary)";
export const BRAND_MENU = "var(--color-menu)";
/** Dark blue for fixed-hex UI (e.g. benchmarks “more details”); #142F40 */
export const BRAND_BACKGROUND = "var(--color-background)";
// Ready-to-use in places that require actual colour (e.g. Nivo charts)
export const BRAND_PRIMARY_RGB = "rgb(var(--color-primary))";
export const BRAND_SECONDARY_RGB = "rgb(var(--color-secondary))";
export const BRAND_MENU_RGB = "rgb(var(--color-menu))";
export const BRAND_BACKGROUND_RGB = "rgb(var(--color-background))";

// Status colours — themed via `--success` / `--danger` in global.css (light + dark)
/** “Active / positive” success green; #068D51 light, lighter on dark */
export const BRAND_SUCCESS = "var(--success)";
export const BRAND_SUCCESS_RGB = "rgb(var(--success))";
/** Error / negative red; #E50000 light, softer on dark */
export const BRAND_DANGER = "var(--danger)";
export const BRAND_DANGER_RGB = "rgb(var(--danger))";

// Accent colours
export const BRAND_ACCENT1 = "var(--color-accent1)";
export const BRAND_ACCENT2 = "var(--color-accent2)";
export const BRAND_ACCENT3 = "var(--color-accent3)";

export const BRAND_ACCENT1_RGB = "rgb(var(--color-accent1))";
export const BRAND_ACCENT2_RGB = "rgb(var(--color-accent2))";
export const BRAND_ACCENT3_RGB = "rgb(var(--color-accent3))";

/** Referral / “friend discount” UI — teal/cyan tokens aligned with secondary & primary (`--color-referral*` in global.css) */
export const BRAND_REFERRAL = "var(--color-referral)";
export const BRAND_REFERRAL_SOFT = "var(--color-referral-soft)";
export const BRAND_REFERRAL_MUTED = "var(--color-referral-muted)";
export const BRAND_REFERRAL_BORDER = "var(--color-referral-border)";
export const BRAND_REFERRAL_SURFACE = "var(--color-referral-surface)";
export const BRAND_REFERRAL_SURFACE_STRONG = "var(--color-referral-surface-strong)";
export const BRAND_REFERRAL_RGB = "rgb(var(--color-referral))";
export const BRAND_REFERRAL_SOFT_RGB = "rgb(var(--color-referral-soft))";
export const BRAND_REFERRAL_MUTED_RGB = "rgb(var(--color-referral-muted))";
export const BRAND_REFERRAL_BORDER_RGB = "rgb(var(--color-referral-border))";
export const BRAND_REFERRAL_SURFACE_RGB = "rgb(var(--color-referral-surface))";
export const BRAND_REFERRAL_SURFACE_STRONG_RGB = "rgb(var(--color-referral-surface-strong))";

// Consolidated brand colours object (menu listed first to reflect higher importance)
export const BRAND_COLORS = {
  menu: BRAND_MENU,
  background: BRAND_BACKGROUND,
  primary: BRAND_PRIMARY,
  secondary: BRAND_SECONDARY,
  success: BRAND_SUCCESS,
  danger: BRAND_DANGER,
  accent1: BRAND_ACCENT1,
  accent2: BRAND_ACCENT2,
  accent3: BRAND_ACCENT3,
  referral: BRAND_REFERRAL,
  referralSoft: BRAND_REFERRAL_SOFT,
  referralMuted: BRAND_REFERRAL_MUTED,
  referralBorder: BRAND_REFERRAL_BORDER,
  referralSurface: BRAND_REFERRAL_SURFACE,
  referralSurfaceStrong: BRAND_REFERRAL_SURFACE_STRONG
};
export const rgb_to_hex = (rgb: string) => {
  let input = rgb;
  // If the input contains a CSS var (e.g. "rgb(var(--color-primary))"), resolve it to actual numbers first
  const varMatch = rgb.match(/var\((--[^)]+)\)/);
  if (varMatch && typeof window !== 'undefined') {
    const varName = varMatch[1];
    const rgbValue = getComputedStyle(document.documentElement).getPropertyValue(varName).trim();
    if (rgbValue) {
      input = `rgb(${rgbValue})`;
    }
  }

  const matches = input.match(/\d+/g);
  if (!matches || matches.length < 3) {
    return '#000000'; // Fallback
  }
  const [r, g, b] = matches.map(Number);
  return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
};